export const AUTH_ACCESS_TOKEN_KEY = 'auth.access_token';
export const AUTH_SESSION_TOKEN_KEY = 'auth.session_token';
export const AUTH_STATUS_KEY = 'auth.status';
export const AUTH_HAS_PIN_CODE_KEY = 'auth.has_pin_code';
